var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputerPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6677 28.6338H16.3322V36.1321H24.6677V28.6338Z",
    fill: "#CBD6DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4922 34.5237H14.5076C13.6194 34.5237 12.8995 35.2436 12.8995 36.1317C12.8995 37.0198 13.6194 37.7397 14.5076 37.7397H26.4922C27.3803 37.7397 28.1002 37.0198 28.1002 36.1317C28.1003 35.2436 27.3803 34.5237 26.4922 34.5237Z",
    fill: "#AFBBC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3371 2.26019H4.6628C3.27659 2.26019 2.15283 3.38402 2.15283 4.77016V28.272C2.15283 29.6582 3.27659 30.7819 4.6628 30.7819H36.3371C37.7234 30.7819 38.847 29.6582 38.847 28.272V4.77016C38.847 3.38402 37.7233 2.26019 36.3371 2.26019Z",
    fill: "#CBD6DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1696 5.93805H5.83044V25.8844H35.1696V5.93805Z",
    fill: "#2BC5B1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 29.4255C21.1032 29.4255 21.5921 28.9365 21.5921 28.3334C21.5921 27.7302 21.1032 27.2412 20.5 27.2412C19.8968 27.2412 19.4078 27.7302 19.4078 28.3334C19.4078 28.9365 19.8968 29.4255 20.5 29.4255Z",
    fill: "#465059"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6677 30.7823H16.3322V32.6451H24.6677V30.7823Z",
    fill: "#AFBBC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerPc);
export default __webpack_public_path__ + "static/media/computer-pc.e531c4a17c9feebd7ff8e936128d96ff.svg";
export { ForwardRef as ReactComponent };